import { combineReducers } from "redux";

import petenquiry from "../features/admin/pet_enquiry/pet_enquiry/Slice";

import common from "../features/admin/common/Slice";

const pet_enquirys = combineReducers({
    petenquiry,
    common
});

export default pet_enquirys;